import { BONUS_BY_ID_GET_SUCCESS, BONUS_BY_ID_GET_FAILURE } from '../actions/types';
import config from '../configs';

const initialState = {
  config,
  defaults: {
    placement: null,
    isLoading: false,
    isLoaded: false,
  },
};

export default (state = initialState, action) => {
  const namespaceId = action?.options?.namespace || action?.context?.options?.namespace || 'default';
  const namespace = `namespace-${namespaceId}`;
  const { defaults } = state;
  const { [namespace]: namespaceState = defaults } = state;

  switch (action.type) {
    case BONUS_BY_ID_GET_SUCCESS: {
      const placement = action.payload.response[0] || {};

      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          placement,
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    case BONUS_BY_ID_GET_FAILURE: {
      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          placement: null,
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    default: {
      const { options = {} } = action;
      if (options.success === BONUS_BY_ID_GET_SUCCESS) {
        return {
          ...state,
          [namespace]: {
            ...namespaceState,
            isLoading: true,
          },
        };
      }

      return state;
    }
  }
};
